import { useFrameworkControlAnnualWheelActivitySelectorDialog } from "./FrameworkControlAnnualWheelActivitySelectorDialog.hooks.ts";
import { DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import SelectableAnnualWheelActivityTable from "@common/components/selectableAnnualWheelActivityTable/SelectableAnnualWheelActivityTable.tsx";
import { useGetSelectableGroupEntities } from "../../../dialogs/ControlsForm/ControlsForm.hooks.ts";

export interface FrameworkControlAnnualWheelActivitySelectorDialogProps {
    controlTemplateId: string;
    controlId: string;
    onCloseDialog: () => void;
    onAnnualWheelActivitiesSaved: () => void;
    frameworkGroupEntityIds: Array<string>;
}

function FrameworkControlAnnualWheelActivitySelectorDialog(props: FrameworkControlAnnualWheelActivitySelectorDialogProps) {
    const { translateString } = useTranslation();
    const { isLoading, data, saveModel, modelUpdater, onCreateAnnualWheelActivities, isSaving } = useFrameworkControlAnnualWheelActivitySelectorDialog(props);
    const { groupEntities, showGroupEntitySelector } = useGetSelectableGroupEntities(props.frameworkGroupEntityIds);

    return (
        <DotLegalDialog
            buttonOkText={translateString("create")}
            open
            onDialogClose={props.onCloseDialog}
            onOkClick={onCreateAnnualWheelActivities}
            inProgress={isSaving}
            size={"lg"}
            header={translateString("addTaskToControl")}
        >
            <SelectableAnnualWheelActivityTable
                isLoading={isLoading}
                selectableAnnualWheelActivities={data ?? []}
                selectedAnnualWheelActivities={saveModel.templates.map((t) => t.templateId)}
                onAddAnnualWheelActivity={modelUpdater.onAnnualWheelActivityAdd}
                onRemoveAnnualWheelActivity={modelUpdater.onAnnualWheelActivityRemove}
                showGroupCompaniesColumn={showGroupEntitySelector}
                groupEntitiesOptions={groupEntities}
                templateSelections={saveModel.templates}
                onTemplateDeadlineChange={modelUpdater.onTemplateDeadlineChange}
                onTemplateRecurrenceChange={modelUpdater.onTemplateRecurrenceChange}
                onTemplateGroupEntitiesChange={modelUpdater.onTemplateGroupEntitiesChange}
            />
        </DotLegalDialog>
    );
}

export default FrameworkControlAnnualWheelActivitySelectorDialog;
